var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyTxn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1467_8632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 21.875C34.8827 21.875 37.625 19.1327 37.625 15.75C37.625 12.3673 34.8827 9.625 31.5 9.625C28.1173 9.625 25.375 12.3673 25.375 15.75C25.375 19.1327 28.1173 21.875 31.5 21.875Z",
    fill: "#2DB49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 27.9825C7.224 27.9825 7.448 27.8968 7.61862 27.7261L10.2436 25.1011C10.5857 24.759 10.5857 24.206 10.2436 23.8639C9.9015 23.5218 9.3485 23.5218 9.00637 23.8639L7.875 24.9953V14.8759C7.875 14.3938 8.267 14.0009 8.75 14.0009H21.875C22.3589 14.0009 22.75 13.6089 22.75 13.1259C22.75 12.6429 22.3589 12.2509 21.875 12.2509H8.75C7.30275 12.2509 6.125 13.4286 6.125 14.8759V24.9953L4.99362 23.8639C4.6515 23.5218 4.0985 23.5218 3.75637 23.8639C3.41425 24.206 3.41425 24.759 3.75637 25.1011L6.38137 27.7261C6.552 27.8976 6.776 27.9825 7 27.9825ZM31.5 24.5C31.0161 24.5 30.625 24.892 30.625 25.375V30.625C30.625 31.1071 30.233 31.5 29.75 31.5H7C6.51612 31.5 6.125 31.892 6.125 32.375C6.125 32.858 6.51612 33.25 7 33.25H29.75C31.1972 33.25 32.375 32.0723 32.375 30.625V25.375C32.375 24.892 31.9839 24.5 31.5 24.5ZM31.5 8.75C27.6404 8.75 24.5 11.8904 24.5 15.75C24.5 19.6096 27.6404 22.75 31.5 22.75C35.3596 22.75 38.5 19.6096 38.5 15.75C38.5 11.8904 35.3596 8.75 31.5 8.75ZM31.5 21C28.6046 21 26.25 18.6454 26.25 15.75C26.25 12.8546 28.6046 10.5 31.5 10.5C34.3954 10.5 36.75 12.8546 36.75 15.75C36.75 18.6454 34.3954 21 31.5 21Z",
    fill: "#162930"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1467_8632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTxn);
export default __webpack_public_path__ + "static/media/empty-txn.e121e0de.svg";
export { ForwardRef as ReactComponent };